import FooterButton from "../FooterButton";

const Footer = () => {
  return (
    <div className="w-full sticky bottom-0 z-50 bg-white border-t border-gray-100 shadow-[0_-4px_16px_rgba(0,0,0,0.06)]">
      <div className="flex items-stretch h-16">
        <FooterButton to="/home" icon="home" label="Beranda" />
        <FooterButton to="/profile" icon="profile" label="Profil" />
      </div>
    </div>
  );
};

export default Footer;
